import { apiV2, errorHandler } from "./index";
import {
  FETCH_DASHBOARD_STATS_REQUEST,
  FETCH_DASHBOARD_STATS_SUCCESS,
  FETCH_DASHBOARD_STATS_FAILURE,
  FETCH_APP_STORE_RATINGS_REQUEST,
  FETCH_APP_STORE_RATINGS_SUCCESS,
  FETCH_APP_STORE_RATINGS_FAILURE,
} from "../constants/ActionTypes";

/**
 * Fetch dashboard statistics
 */
export const fetchDashboardStats = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DASHBOARD_STATS_REQUEST });

    const response = await apiV2.get('/admin/dashboard/stats');

    dispatch({
      type: FETCH_DASHBOARD_STATS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    dispatch({
      type: FETCH_DASHBOARD_STATS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch dashboard statistics',
    });
    errorHandler(dispatch, error.response);
  }
};

/**
 * Fetch app store ratings and reviews
 */
export const fetchAppStoreRatings = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_APP_STORE_RATINGS_REQUEST });

    const response = await apiV2.get('/admin/dashboard/app-store-ratings');

    dispatch({
      type: FETCH_APP_STORE_RATINGS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    console.error('Error fetching app store ratings:', error);
    dispatch({
      type: FETCH_APP_STORE_RATINGS_FAILURE,
      payload: error.response?.data?.message || 'Failed to fetch app store ratings',
    });
    // Don't show error to user for app store ratings - it's not critical
  }
};
